export default class ResponsiveImageLoader  {

  constructor(options)
  {
    this.options = options;
    var imageBreakPointSizes = this.setItemFromOptionsOrDefault("imageBreakPointSizes");
    if(!imageBreakPointSizes)
    {
      //Should look something like  [640, 1024, 1280, 1440]
      throw "No Image Break Points given to Responsive Image Loader";
      return;
    }

    this.DESKTOP_BREAKPOINT_WIDTH = this.setItemFromOptionsOrDefault("desktopBreakPointWidth",768);
    this.DEBOUNCE_DURATION_MILLISECONDS = this.setItemFromOptionsOrDefault("debounceDurationMilliseconds",500);
    this.LAZY_LOAD_ALL_IMAGES_ENABLED = this.setItemFromOptionsOrDefault("lazyLoadAllImages",false);
    this.LAZY_LOAD_BY_CLASS_ENABLED = this.setItemFromOptionsOrDefault("lazyLoadByClass",false);
    this.LAZY_LOAD_CLASS = "-lazy-load";
    this.LAZY_LOAD_PERCENTAGE_OF_WINDOW_HEIGHT = 10;
    this.RESIZE_IMAGE_BREAKPOINTS = imageBreakPointSizes;

    //VARIABLES
    this.previousWindowWidth = NaN;
    this.m_lastFetchedImageSize = 0;
    this.m_bIsDesktop = false;
    this.m_debounceTimer = null;

    this.initialiseListeners();

    window.setTimeout(() => this.onWindowResizeSettled(), 500);
  }

  initialiseListeners()
  {
    if(this.LAZY_LOAD_ALL_IMAGES_ENABLED || this.LAZY_LOAD_BY_CLASS_ENABLED)
    {
      $(window).scroll(() => this.onWindowScroll());
    }

    $("body").on("responsive-image-check",() => this.onWindowResizeSettled(false))
    $(window).on("resize", () => this.onWindowResized());
    $("body").on("responsive-image", (e,_additionalEventObject) => this.onResponsiveImageEvent(e,_additionalEventObject));
  }

  onWindowResized()
  {
    //Add some debounce incase they're resizing the window very quickly between small and large, you dont want to load the medium sized images if they dont really need them
    this.resetDebounceTimer();
  }

  onWindowScroll()
  {
    var $dataResponsiveLazyLoadElements = false;

    if(this.LAZY_LOAD_ALL_IMAGES_ENABLED)
    {
      $dataResponsiveLazyLoadElements = $("[data-responsive-image]:visible");
    }
    else if(this.LAZY_LOAD_BY_CLASS_ENABLED)
    {
      $dataResponsiveLazyLoadElements = $(".-lazy-load[data-responsive-image]:visible");
    }
    else
    {
      return;
    }
    this.fetchIdealResponsiveImagery($dataResponsiveLazyLoadElements);
  }

  setItemFromOptionsOrDefault(_key,_default)
  {
    if(typeof _default === "undefined")
    {
      _default = false;
    }

    if(typeof this.options[_key] === "undefined")
    {
      return _default;
    }

    return this.options[_key];
  }

  onResponsiveImageEvent(e,_additionalEventObject = false)
  {
    if(!_additionalEventObject || typeof _additionalEventObject.$responsiveImageTargets === "undefined")
    {
      console.log("---onResponsiveImageEvent--- Failed to get responsive Image Targets in _additionalEventObject");
      console.log(_additionalEventObject);
      return false;
    }
    console.log("onResponsiveImageEvent");


    var onCompleteCallback = (typeof _additionalEventObject.onComplete !== "undefined") ? _additionalEventObject.onComplete : null;

    this.fetchIdealResponsiveImagery(_additionalEventObject.$responsiveImageTargets, onCompleteCallback);
  }


  resetDebounceTimer()
  {
    if(this.m_debounceTimer !== null)
    {
      window.clearTimeout(this.m_debounceTimer);
      this.m_debounceTimer = null;
    }

    this.m_debounceTimer = window.setTimeout(() => this.onWindowResizeSettled(), this.DEBOUNCE_DURATION_MILLISECONDS);
  }

  isDesktopBreakpoint()
  {
    var windowSize = $(window).width();
    var bIsDesktop = windowSize >= this.DESKTOP_BREAKPOINT_WIDTH;
    return bIsDesktop;
  }

  onWindowResizeSettled(_ignoreIfSameWindowWidth) 
  {
    if(typeof _ignoreIfSameWindowWidth === "undefined")
    {
      _ignoreIfSameWindowWidth = true;
    }

    var windowSize = $(window).width();

    if(_ignoreIfSameWindowWidth && this.previousWindowWidth === windowSize)
    {
      //No point in resizing the images, as they're based on the width of the browser
      //it may have been vertically resized, like scrolling on an ipad and the tab bar disappears
      return;
    }

    this.previousWindowWidth = windowSize;
    this.fetchIdealResponsiveImagery();
  }


  isElementOnScreenOrNear(_$element)
  {
    var scrollTop = $(window).scrollTop();
    var elementTopOffset = _$element.offset().top;
    var windowInnerHeight = $(window).innerHeight();
    var scrollTopBottomWindow = scrollTop + windowInnerHeight;
    var scrollTopBottomWindowWithBottomBuffer = scrollTopBottomWindow + (windowInnerHeight*(this.LAZY_LOAD_PERCENTAGE_OF_WINDOW_HEIGHT*0.01));
    if(scrollTopBottomWindowWithBottomBuffer < elementTopOffset)
    {
      return false;
    }

    return true;
  }


  fetchIdealResponsiveImagery(_$selectedItems = false,_onLoadedCallback)
  {
    if(typeof _onLoadedCallback === "undefined")
    {
      _onLoadedCallback = null;
    }
    // console.log("--fetchIdealResponsiveImagery--");
    if(!_$selectedItems)
    {
      _$selectedItems = $("[data-responsive-image]:visible").not(".-defer-loading");
    }

    _$selectedItems = _$selectedItems.not(".-loading").not(".-error-loading");

    this.m_bIsDesktop = this.isDesktopBreakpoint()
    var queryParams = "?width=";
    var context = this;
    _$selectedItems.each(function()
    {
      var $this = $(this);
      // if($this.hasClass("-lazy-load"))
      if((context.LAZY_LOAD_ALL_IMAGES_ENABLED || ($this.hasClass(context.LAZY_LOAD_CLASS && context.LAZY_LOAD_BY_CLASS_ENABLED))) && !context.isElementOnScreenOrNear($this))
      {
        // console.log("Not on screen so not loading the image");
        return;
      }

      var responsiveImageURL = $this.data("responsive-image");
      var recommendedImageSize = context.getRecommendedImageSizeFromElement($this);
      var fullQueryURL = context.appendGetParamaters("width",recommendedImageSize,responsiveImageURL);



      var backgroundImageURL = $this.css("background-image");
      if(backgroundImageURL.indexOf(fullQueryURL.replace("../","")) >= 0)
      {
        if(typeof _onLoadedCallback === "function")
        {
          _onLoadedCallback.call();
        }
        return;
      }


      if(backgroundImageURL === "none")
      {
        // console.log("Has not loaded atleast one image");
        // $this.addClass("-loading");
        context.addLoadingItemsToElement($this);
      }
      else
      {
        // console.log("loading new");
        // console.log("backgroundImageURL: " + backgroundImageURL);
        // console.log("fullQueryURL: " + fullQueryURL);
      }
      

      fullQueryURL = context.appendGetCropValue($this,fullQueryURL);
      context.preloadImage(fullQueryURL,$this, recommendedImageSize, _onLoadedCallback);
    });
  }

  addLoadingItemsToElement(_$element)
  {
    _$element.addClass("-loading");

    if(_$element.find(".uil-spin-css").length)
    {
      return;
    }

      
    var html = "<div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>";

    _$element.append(html);
  }


  appendGetCropValue(_$element,_responsiveImageURL)
  {
    var cropParams = false;
    if(this.m_bIsDesktop)
    {
      var elementWidth = (_$element.width()|0);
      var elementHeight = (_$element.height()|0);

      if(elementWidth && elementHeight)
      {
        if(elementWidth === elementHeight)
        {
            cropParams = _$element.data("crop-square");
        }
        else if(elementWidth > elementHeight)
        {
            cropParams = _$element.data("crop-landscape");
        }
        else if(elementHeight > elementWidth)
        {
            cropParams = _$element.data("crop-portrait");
        }
      }
      else
      {
        //go off classes of the element (if width and height cant be detected)

        if(_$element.hasClass("-even-width-height")  || _$element.hasClass('-slightly-short'))
        {
          cropParams = _$element.data("crop-square");
        }
        else if(_$element.hasClass("-double-width") || _$element.hasClass("-four-by-three") || _$element.hasClass("-sixteen-by-ten"))
        {
          cropParams = _$element.data("crop-landscape");
        }
        else if(_$element.hasClass('-three-by-four') || _$element.hasClass('-slightly-long'))
        {
          cropParams = _$element.data("crop-portrait") ;
        }
        else 
        {
          cropParams = _$element.data("crop-landscape");
        }


        //Default to landsacpe if all else fails
      }
    }
    else
    {
      //Mobile
      cropParams = _$element.data("crop-mobile");
    }

    if(!cropParams)
    {
      return _responsiveImageURL;
    }

    _responsiveImageURL = this.appendGetParamaters("crop",cropParams, _responsiveImageURL);

    return _responsiveImageURL;
  }

  appendGetParamaters(_key,_value, _stringToReturn)
  {
    if(_stringToReturn.indexOf("?") > -1)
    {
      _stringToReturn += "&";
    }
    else
    {
      _stringToReturn += "?";
    }

    _stringToReturn += _key + "=" + _value;
    return _stringToReturn;
  }

  getRecommendedImageSizeFromElement(_$element)
  {
    var imageContainerSize = _$element.width();
    var fetchImageSize = this.RESIZE_IMAGE_BREAKPOINTS[0];
    //Fetch the minimum biggest size
    for (var i = 0; i < this.RESIZE_IMAGE_BREAKPOINTS.length; i++)
    {
      var imageBreakpointSize = this.RESIZE_IMAGE_BREAKPOINTS[i];
      if(imageBreakpointSize > imageContainerSize)
      {
        fetchImageSize = imageBreakpointSize;
        break;
      }
      else if(i === (this.RESIZE_IMAGE_BREAKPOINTS.length -1) )
      {
        fetchImageSize = imageBreakpointSize;
      }
    }

    return fetchImageSize;
  }

  removeLoadingState(_$element)
  {
      _$element.removeClass("-loading");
      _$element.find(".uil-spin-css").remove();

  }

  //Stops the 
  preloadImage(source, _$element, _initialRecommendedImageSize,_onCompleteCallback)
  {
    if(typeof _onCompleteCallback !== "function")
    {
      _onCompleteCallback = null;
    }

    var image = new Image();
    image.src = source;
    var context = this;
    image.onload = function()
    {
      context.removeLoadingState(_$element);
      _$element.addClass("-loaded");
      //Now that it's loaded we just need to make sure it is still relevant (the browser hasnt changed size again since)
      var currentRecommendedImageSize = context.getRecommendedImageSizeFromElement(_$element);
      if(currentRecommendedImageSize !== _initialRecommendedImageSize)
      {
        return; //dont do anything, as this image might have loaded AFTEr another image was requested, and is now irrelavant
      }

      var cssBackground = 'url(' + image.src + ')';
      _$element.css('background-image', cssBackground);

      if(_$element.hasClass("-native-aspect-ratio") && _$element.hasClass("-aspect-ratio"))
      {
        //If it has this class, then it overrides the class based aspect ratio to the native image aspect ratio
        // padding-bottom: (100/160) * 100%; (based on this css)
        var paddingBottom = (image.height/image.width) * 100;
        _$element.css("padding-bottom",paddingBottom + "%");
      }
      if(_onCompleteCallback)
      {
        _onCompleteCallback.call();
      }

    };

    image.onerror = function()
    {
      context.removeLoadingState(_$element);
      _$element.addClass("-loaded");
      _$element.addClass("-error-loading");
      if(_onCompleteCallback)
      {
        _onCompleteCallback.call();
      }
    };

  }



}



/** WEBPACK FOOTER **
 ** ./system/responsive-image-loader.js
 **/